import React, { useState, useEffect } from "react";
import classNames from "classnames";
import MainHeading from "../../MainHeading/MainHeading";
import SmallHeading from "../../SmallHeading/SmallHeading";
import LoginHelper from "../../../helper/LoginHelper";
import Constants from "../../../helper/Constants";
import ValidateAccount from "../../../checks/ValidateAccount";
import ValidatePost from "../../../checks/ValidatePost";
import DOMCheck from "../../../checks/DOMCheck";
import AjaxCheck from "../../../checks/AjaxCheck";
import useKeyPress from "../../../helper/UseKeyPress";
import ImageCheck from "../../../checks/ImageCheck";

const Body = (props) => {
  const [loading, setLoading] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const { id } = props.match.params;
  const { host } = props.match.params;

  const pressedEnter = useKeyPress("Enter");

  useEffect(() => {
    if (userName.length > 0 && password.length > 0) {
      nextClickHandler();
    }
  }, [pressedEnter]);

  const userNameChanged = (e) => setUserName(e.target.value);
  const passwordChanged = (e) => setPassword(e.target.value);

  const completedTasks = [];
  let errors;
  let postName;

  const nextClickHandler = () => {
    setLoading(true);
    setLoginFailed(false);

    const decodedHost = decodeURIComponent(atob(host));

    LoginHelper.attemptLogin(userName, password)
      .then(() => {
        console.log("Logged In");
      })
      .then(() => ValidatePost(id))
      .then((msg) => {
        completedTasks.push(msg.message);
        postName = msg.postName;
      })
      .then(() => ValidateAccount())
      .then((msg) => {
        completedTasks.push(msg);
        console.log(msg);
      })
      .then(() => ImageCheck(decodedHost))
      .then((msg) => completedTasks.push(msg))
      .then(() => DOMCheck(decodedHost))
      .then((msg) => completedTasks.push(msg))
      .then(() => AjaxCheck(decodedHost))
      .then((msg) => completedTasks.push(msg))
      .catch((err) => {
        errors = err;
      })
      .finally(() => {
        // console.log(completedTasks);
        // console.log(errors);

        if (errors === Constants.Login.LOGIN_FAILED) {
          setLoading(false);
          setLoginFailed(true);
          return;
        }

        props.history.push({
          pathname: `/summary/${host}/${id}`,
          state: {
            completedTasks,
            errors,
            postName
          }
        });
      });
  };

  const buttonClassName = classNames(
    "text-white text-xl font-bold py-2 px-4 rounded  w-1/5 text-center h-16 ",
    { narrativeGradient: !loading },
    { narrativeGradientClicked: loading }
  );

  const buttonChildren = loading ? (
    <div id="loading" />
  ) : (
    <span className="graphikFont">Run Check</span>
  );

  const checkingText = loading && (
    <div className="mt-8">
      <span className="graphikFont" style={{ color: "rgba(26, 26, 26, 0.45)" }}>
        Checking your website now
      </span>
    </div>
  );

  const loginFailedText = loginFailed && (
    <div className="mt-8">
      <span className="graphikFont" style={{ color: "rgba(26, 26, 26, 1.00)" }}>
        Log In Failed, Please try again
      </span>
    </div>
  );
  return (
    <div className="w-full mt-12 flex flex-col justify-center">
      <MainHeading heading="Trouble with your Narrative post?" />
      <SmallHeading heading="Please login to your Narrative account" />
      <div className="flex flex-col">
        <div className="mt-24 flex flex-row" style={{ marginLeft: "40%" }}>
          <input
            className="inputBorder graphikFont text-sm"
            placeholder="Username"
            style={{ width: "15.8%" }}
            onChange={userNameChanged}
            disabled={loading}
            value={userName}
          />
          <input
            className="inputBorder graphikFont text-sm ml-4"
            placeholder="Password"
            type="password"
            style={{ width: "15.8%" }}
            onChange={passwordChanged}
            disabled={loading}
            value={password}
          />
        </div>
        <div className="mt-12">
          <button disabled={userName.length === 0 || password.length === 0} onClick={nextClickHandler} className={buttonClassName}>
            {buttonChildren}
          </button>
          {checkingText}
          {loginFailedText}
        </div>
      </div>
    </div>
  );
};

export default Body;
